import {Injectable} from '@angular/core';
import {ActiveStatus, VenueAccessType, VenueGet, VenueService as API} from '../../generated/sales-terminal-client';
import {Observable, tap} from 'rxjs';
import {SnackService} from '../snack/snack.service';
import {PageableResult, PageableSearch, ScrollLoadService} from '../../components/scroll-load-component/scroll-load.component';
import {ScrollLoad} from '../../components/scroll-load-component/ScrollLoad';
import {AuthService} from "../auth/auth.service";

export interface VenueSearch extends PageableSearch {
  q?: string;
  l?: string;
}

@Injectable({
  providedIn: 'root'
})
export class VenueService implements ScrollLoadService<VenueGet> {

  constructor(private api: API,
              private snackService: SnackService,
              private authService: AuthService) {}

  public search(data: VenueSearch): Observable<PageableResult<VenueGet>> {
    return this.api.searchVenues(
      ActiveStatus.Active,
      data.q,
      null,
      null,
      this.authService.isVenueReport ? VenueAccessType.Owner : null,
      null,
      data.page,
      data.pageSize
    ).pipe(
      tap({error: (e) => this.snackService.showBackendError(e)})
    );
  }
  displayScrollLoadOption(option: VenueGet): string {
    return option.name || '';
  }
  displayScrollLoadSelection(selection: VenueGet): string | undefined {
    return selection?.name || undefined;
  }
  getScrollLoad(pageSize?: number, idKey?: string): ScrollLoad<VenueGet> {
    return new ScrollLoad<VenueGet>(pageSize || 20, idKey || 'id', 'q');
  }
}
